<div class="@container/workarea">
    @if(working)
    {
        <div class="flex items-center justify-center min-h-screen">
            <div class="flex flex-col items-center">
                <div class="text-lg">Loading</div>
                <div class="mt-4 w-12 h-12 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
            </div>
        </div>
    }
    @else
    {
        <div class="grid grid-cols-2 bg-[#e4e4e72e] gap-4">
        @for(translations of data; track $index)
        {
            <div class="bg-white p-2 max-h-64 rounded-lg flex flex-col">
                <div class="p-2 font-semibold">
                    <div class="flex text-sm">
                        <div class="flex" style="flex-grow:1; "><img [src]="'/flags/'  + translations.CultureCode + '.png'" style="margin-right:20px; width:20px;height:20px;" />Global list translations</div>
                        <div class="flex" style="flex-grow:1;" ng-repeat="field in widget.FieldHeaders"></div>
                    </div>    
                </div>
                <div class="overflow-y-auto pr-2">
                    <ul>
                        
                        @for(translation of translations.TranslationData; track $index)
                        {
                        <li style="border-left:3px solid white;margin-bottom:5px;" class="border-t p-1">
                            <div class="flex text-sm">
                                <div style="padding-right:5px; width:150px; flex-grow:1;cursor:pointer;" (click)="goToPimUrl(translation.Url)">{{translation.GlobalListAlias}} ({{translation.NumberOfUntranslatedValues}})</div>
                                @for(field of translations.FieldHeaders; track $index)
                                {
                                <div style="padding-right:5px; width:150px; flex-grow:1;">
                                    @if(translation.Fields[field]) 
                                    {
                                    <div style="cursor: pointer" (click)="goToPimUrl(translation.Fields[field].Url)">
                                        {{translation.Fields[field].Alias}}  ({{translation.Fields[field].NumberOfUntranslatedValues}})
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </div>    
        }
        </div>
    }
</div>
